import { useMemo, useState } from 'react';
import { IconButton } from '@mui/material';
import { SearchIcon } from '@heroicons/react/outline';
import { SearchTextInput } from '@styles/StyledTextField';
import { SearchInputWrapper } from './SearchInput';

interface ISearchInputProps {
  isWithDeleteIcon?: boolean;
  placeholder?: string;
  onSearch(value: string): void;
}

export const SmsSearch = ({ placeholder, onSearch }: ISearchInputProps) => {
  const [searchText, setSearchText] = useState<string>('');

  const disableSearch = useMemo(() => !(searchText || '').trim().length, [searchText]);

  return (
    <SearchInputWrapper>
      <SearchTextInput
        fullWidth
        value={searchText}
        id="outlined-basic"
        placeholder={placeholder || 'Search'}
        variant="outlined"
        onChange={({ target: { value } }) => {
          setSearchText(value);
          onSearch(value);
        }}
      />

      <IconButton
        aria-label="search"
        disabled={disableSearch}
        sx={{ p: '10px' }}
        onClick={() => onSearch(searchText)}
      >
        <SearchIcon
          width={20}
          color={'#5C5C5C'}
        />
      </IconButton>
    </SearchInputWrapper>
  );
};
